import { gql } from '@apollo/client';

export const EDIT_FILE_NAME = gql`
  mutation editFileName($fileId: Float!, $title: String!, $newFileName: String!, $user: String!) {
    editFileName(fileId: $fileId, title: $title, newFileName: $newFileName, user: $user)
  }
`;
